<script>
import "./vfigma.input.scss";

export default {
  props: {
    input: String,
    placeholder: String,
    disabled: Boolean,
    enter: Function,
    esc: Function,
    optional: Boolean,
    focus: Function,
    blur: Function,
    readonly: Boolean,
    click: Function,
    selectOnFocus: Boolean,
    maxlength: String,
    disableLineBreak: Boolean,
  },
  data() {
    return {
      focused: false,
    };
  },
  methods: {
    enterCb: function ($event) {
      if (this.disableLineBreak) {
        $event.preventDefault();
      }
      this.$emit("enter");
    },
  },
};
</script>

<template>
  <f-field
    :optional="optional"
    :focused="focused"
    :disabled="disabled"
    class="f-textarea"
  >
    <template v-slot:label><slot name="label"></slot></template>
    <template v-slot:content>
      <div class="f-input-container" :class="{ focus: focused }">
        <textarea
          class="keepfocus f-input f-form-allow-enter"
          :value="input"
          :placeholder="placeholder"
          :disabled="disabled"
          :readonly="readonly"
          :maxlength="maxlength"
          @focus="
            if (selectOnFocus) $event.target.select();
            focused = true;
            $emit('focus');
          "
          @blur="
            focused = false;
            $emit('blur');
          "
          @input="$emit('update:input', $event.target.value)"
          @click="$emit('click')"
          @keydown.enter.exact="enterCb($event)"
          @keydown.esc="$emit('esc')"
          type="text"
        />
        <div class="actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </template>
    <template v-slot:helper><slot name="helper"></slot></template>
  </f-field>
</template>

<style lang="scss" >
.f-textarea {
  .f-input-container {
    display: flex;
    flex-direction: column;
  }

  textarea {
    overflow: scroll;
    resize: none;
    height: 100%;
    flex: 1;

    /* width */
    &::-webkit-scrollbar {
      width: 16px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-track:hover {
      border-radius: 2px;
      background: #f3f3f3;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: rgba(22, 22, 21, 0.1);
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #dddddd;
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 8px;
      border: solid transparent 4px;
      background-clip: content-box;
    }
  }
}
</style>